import React from "react";
import "./Industries.css"; // Make sure this is imported

const Overview = () => {
  return (
    <div className="overview">
      <h2 className="section-title">Industries We Serve</h2>
      <p className="overview-text" style={{color:"black"}}>
        At Chiselon Technologies Pvt. Ltd., we believe that every industry faces unique challenges, 
        and therefore deserves customized solutions. Our dual expertise in talent acquisition and technology services 
        allows us to empower organizations across multiple sectors. We don’t just provide staffing or technology — 
        we deliver partnerships tailored to industry-specific needs, ensuring measurable business outcomes.
      </p>
    </div>
  );
};

export default Overview;
